<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col class="col-12 col-sm-6">
              <ValidationProvider ref="time_quantity" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model.number="data.time_quantity"
                  type="Number"
                  label="Tiempo de uso"
                  prepend-inner-icon="fa-solid fa-clock"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="col-12 col-sm-6">
              <ValidationProvider ref="price" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model.number="data.price"
                  type="Number"
                  label="Precio"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <ValidationProvider
                  ref="car_id"
                  rules=""
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.car_id"
                    :items="cars" item-text="patent" item-value="id"
                    label="Auto"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                  ref="spot_id"
                  rules=""
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.spot_id"
                    :items="spots" item-text="address" item-value="id"
                    label="Lugar"
                ></v-select>
              </ValidationProvider>
            </v-col>
            
          </v-row>  -->
          <v-row>
            <v-col class="col-12 col-md-4">
            <ValidationProvider ref="time_from" rules="required" v-slot="{ errors }">
            <v-text-field
                v-model="data.time_from"
                label="Desde"
                prepend-icon="fas fa-calendar"
                type="time"
                :error-messages="errors"
            ></v-text-field>
            </ValidationProvider>
              </v-col>
                <v-col class="col-12 col-md-4">
            <ValidationProvider
                ref="time_to"
                rules="required"
                v-slot="{ errors }"
            >
            <v-text-field
                v-model="data.time_to"
                label="Hasta"
                type="time"
                prepend-icon="fas fa-calendar"
                :error-messages="errors"
            ></v-text-field>
            </ValidationProvider>
                  </v-col>
          </v-row>


          <v-row>
<!--            <v-col class="col-12 col-md-4">
              <v-menu
                ref="menu_dead_line"
                v-model="menu_time_from"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                
              >
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider ref="time_from" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="data.time_from"
                    label="Desde"
                    prepend-icon="fas fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                  ></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="time_from"
                  label="Project Duration"
                  type="date"
                  no-title
                  scrollable
                  @change="menu_time_from = false"
                ></v-date-picker>
              </v-menu>
              
            </v-col>
            <v-col class="col-12 col-md-4">
              
              <v-menu
                ref="menu_dead_line"
                v-model="menu_time_to"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                
              > 
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider
                    ref="time_to"
                    rules="required"
                    v-slot="{ errors }"
                  >
                  <v-text-field
                    v-model="data.time_to"
                    label="Hasta"
                    prepend-icon="fas fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                  ></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="time_to"
                  label="Project Duration"
                  type="date"
                  no-title
                  scrollable
                  @change="menu_time_to = false"
                >
                </v-date-picker>
              </v-menu>
              
            </v-col>-->
            <v-col class="col-12 col-md-4">
              <ValidationProvider ref="state" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.status"
                  label="Estado"
                  prepend-inner-icon="fa-regular fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>         
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';
  import GoogleMapLoader from "@/components/maps/GoogleMapLoader";
  import moment from "moment";

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, GoogleMapLoader},
    computed: {
      ...mapState({
        status: state => state.Rent_orders.status,
      })
    },
    async created() {
      const self = this;
      let filters = {};

      if(this.$route.params.user_id) {
        this.data.user_id = this.$route.params.user_id
        filters.user_id = this.$route.params.user_id
      }
    },
    data() {
      return {
        parentStoreName:"Users",
        parentUrlKey:"user_id",
        storeName: 'Rent_orders',
        title: "Estadias realizadas",
        data: {
          user_id: '',
          price:'',
          time_quantity:'',
          time_from:'',
          time_to:'',
          status:'',
        },
        time_to: '',
        time_from: '',
        menu_time_to: false,
        menu_time_from: false,
      }
    },
    watch: {
      time_to(val) {
        this.time_to = val;
        this.data.time_to = moment(val,"hh:mm A",true).format('HH:mm')//this.formatDateForSave(val);
      },
      time_from(val) {
        this.time_from = val;

        this.data.time_from = moment(val,"hh:mm A",true).format('HH:mm')//this.formatDateForSave(val);
      }
    },
    methods: {
      
    }
  }
</script>
